const doc = [({"en":({"js":({"admin":({"activities":({"billing":({"billing":"Billing", "the_activity_was_saved":"The activity was saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;